module.exports = __webpack_public_path__ + "static/media/Truck.f5fe50d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Truck.svg
// module id = 648
// module chunks = 0